module.exports = __webpack_public_path__ + "img/tabs.1dc1ec08.svg";